export default __webpack_public_path__ + "static/media/logo.072a1c40.svg";